import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import CssBaseline from '@material-ui/core/CssBaseline'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import { makeStyles } from '@material-ui/core/styles'
import Alert from '@mui/material/Alert'

import { actions as authActions } from '../actions'
import { NAME as AUTH_NAME } from '../reducer'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(2),
  },
  paper: {
    width: '100%',
    maxWidth: 380,
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    marginBottom: theme.spacing(1.5),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(3),
    height: 44,
  },
}))

export function LoginForm({ pending, error, login }) {
  const classes = useStyles()
  const [values, setValues] = React.useState({ login: '', password: '' })

  const change = (field) => (event) => setValues({ ...values, [field]: event.target.value })

  const submit = (event) => {
    event.preventDefault()

    if (!pending) {
      login(values.login, values.password)
    }
  }

  const canSubmit = values.login.trim() !== '' && values.password !== '' && !pending

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Paper className={classes.paper} elevation={3}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h6">
          Gradoil
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Войдите, чтобы продолжить
        </Typography>

        <form className={classes.form} onSubmit={submit} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="login"
            name="login"
            label="Логин"
            autoComplete="username"
            autoFocus
            value={values.login}
            onChange={change('login')}
            disabled={pending}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="password"
            name="password"
            label="Пароль"
            type="password"
            autoComplete="current-password"
            value={values.password}
            onChange={change('password')}
            disabled={pending}
          />

          {error ? (
            <Alert severity="error" className={classes.alert}>
              {error}
            </Alert>
          ) : null}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!canSubmit}
          >
            {pending ? <CircularProgress size={22} color="inherit" /> : 'Войти'}
          </Button>
        </form>
      </Paper>
    </div>
  )
}

// Named explicitly: spreading the slice would collide with the `login` action.
const mapStateToProps = (state) => ({
  pending: state[AUTH_NAME].pending,
  error: state[AUTH_NAME].error,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...authActions }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
